import type { ComparisonType} from "@@/shared/comparisons";
import { comparisonTypes } from "@@/shared/comparisons";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "@@/shared/date-time/iso-and-unix";

import { z } from "zod";
import type {
    FeeSourceNotificationsSmsConditionId} from "./fee-source-notifications-sms-condition-id";
import {
    feeSourceNotificationsSmsConditionIdZodSchema,
} from "./fee-source-notifications-sms-condition-id";

type FeeSourceNotificationsSmsConditionCount = {
    readonly _id: FeeSourceNotificationsSmsConditionId;
    readonly _type: "FEE_SOURCE_NOTIFICATIONS_SMS_CONDITION";
    readonly type: "COUNT";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly comparison: ComparisonType;
    readonly value: number;
};

const feeSourceNotificationsSmsConditionCountZodSchema: z.ZodSchema<FeeSourceNotificationsSmsConditionCount> =
    z.object({
        _id: feeSourceNotificationsSmsConditionIdZodSchema,
        _type: z.literal("FEE_SOURCE_NOTIFICATIONS_SMS_CONDITION"),
        type: z.literal("COUNT"),
        _createdAt: isoAndUnixZodSchema,
        comparison: z.enum(comparisonTypes),
        value: z.number(),
    });

export { feeSourceNotificationsSmsConditionCountZodSchema };
export type { FeeSourceNotificationsSmsConditionCount };
